import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    open: false,
}

export const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        showModal: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.open = true
        },
        hideModal: (state) => {
            state.open = false
        },
    },
})

// Action creators are generated for each case reducer function
export const { showModal, hideModal } = modalSlice.actions

export default modalSlice.reducer
